import { degrees2radians } from '../../functions';
import { Vertex2 } from '../vertex-2.class';

// eslint-disable-next-line max-params
export const rotate2AxisCfn = (point: Vertex2, origin: Vertex2, angle: number): Vertex2 => {
	// 0 or any increment of 360, do nothing
	if (angle % 360 === 0) return point;

	// Convert the angle from degrees to radians
	const rad = degrees2radians(angle > 360 ? angle % 360 : angle);

	// Subtract the origin coordinates from the point coordinates
	const dx = point.x - origin.x;
	const dy = point.y - origin.y;

	// Rotate around the z-axis — no rounding (pure math)
	point.x = (dy * Math.sin(rad)) + (dx * Math.cos(rad)) + origin.x;
	point.y = (dy * Math.cos(rad)) - (dx * Math.sin(rad)) + origin.y;

	return point;
}
